export default "__VITE_ASSET__Dh6iKjp5__"